import { useLingui } from '@lingui/react/macro';
import { Pencil } from 'lucide-react';
import { useMemo } from 'react';
import EmptyButton from 'ud-ui/components/empty-button';
import TeamLogo from 'ud-ui/components/team-logo';
import UDTippy from 'ud-ui/components/tippy';
import { GameDetails } from 'modules/games/domain/interfaces/game-details';
import * as styles from './game-result-header.styles';

interface GameResultHeaderProps {
  isLoading: boolean;
  game: GameDetails | null;
  onEditScoreClick?: () => void;
}

export const GameResultHeader = (props: GameResultHeaderProps) => {
  const { isLoading, game, onEditScoreClick } = props;
  const { t } = useLingui();

  const showEditScoreButton = useMemo(() => {
    return Boolean(onEditScoreClick);
  }, [onEditScoreClick]);

  if (isLoading || !game) {
    return <styles.GameResultHeader className="is-loading" />;
  }

  return (
    <styles.GameResultHeader>
      <>
        <styles.GameTeamInfo className="right-logo">
          <div className="team-name">{game.teams[0].name}</div>
          <TeamLogo url={game.teams[0].logo} size={60} />
        </styles.GameTeamInfo>
        <div className="game-score">
          {showEditScoreButton && (
            <styles.EditScoreWrapper>
              <UDTippy content={t`Редактировать`} placement={'top'}>
                <EmptyButton data-testid="edit-score-button" style={{ display: 'inline-block' }} onClick={onEditScoreClick}>
                  <Pencil />
                </EmptyButton>
              </UDTippy>
            </styles.EditScoreWrapper>
          )}
          <styles.ScoreWrapper data-testid="match-score" style={{ marginTop: !showEditScoreButton ? 27 : 0 }}>
            {game.result.firstTeamScore} : {game.result.secondTeamScore}
          </styles.ScoreWrapper>
        </div>
        <styles.GameTeamInfo>
          <TeamLogo url={game.teams[1].logo} size={60} />
          <div className="team-name">{game.teams[1].name}</div>
        </styles.GameTeamInfo>
      </>
    </styles.GameResultHeader>
  );
};
